<template>
  <div class="yhc-component yhc-fzc-black PrivateLabel label" :class="labelClass">
    {{ label }}
  </div>
</template>

<script>
let identifierName = 'PrivateLabel'

export default {
  name: identifierName,
  props: {
    label: {
      type: String,
      require: true,
    },
    labelClass: {
      type: String,
      default: '',
    },
  },
  computed: {},
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.PrivateLabel {
  font-size: 14px;
}
</style>
